import {
    RESET,
    SET_ALERT_MODAL,
    SET_CALLBACK,
    SET_CREATE_MODAL,
    SET_EDIT_MODAL,
    SET_SHOW_MODAL,
    SET_ACTIVITIES_MODAL,
    SET_GAZETTE_MODAL,
    SET_ITEM,
    SET_MODULE
} from "../../utils/constants";

const initialState = () => ({
  showCreateModal: false,
  showEditModal: false,
  showAlertModal: false,
  showActivitiesModal: false,
  showModal: false,
  item: {},
  callback: null,
  module: null
});

const state = {
  ...initialState()
};

const getters = {};

Object.keys(state).forEach(key => {
  Object.assign(getters, {
    [key]: state => state[key]
  });
});

const actions = {
  reset({ commit }) {
    commit(RESET);
  },
  deleteModule({ state, dispatch }) {
    dispatch(`${state.module}/${state.callback}`, state.item.id, {
      root: true
    });
  }
};

const mutations = {
  [RESET](state) {
    Object.assign(state, initialState());
  },
  [SET_CREATE_MODAL](state, payload) {
    state.showCreateModal = payload;
  },
  [SET_SHOW_MODAL](state, payload) {
    state.showModal = payload;
  },
  [SET_EDIT_MODAL](state, payload) {
    state.showEditModal = payload;
  },
  [SET_ALERT_MODAL](state, payload) {
    state.showAlertModal = payload;
  },
  [SET_ACTIVITIES_MODAL](state, payload) {
    state.showActivitiesModal = payload;
  },
    [SET_GAZETTE_MODAL](state, payload) {
    state.showGazettesModal = payload;
  },
  [SET_ITEM](state, payload) {
    state.item = { ...payload };
  },
  [SET_CALLBACK](state, payload) {
    state.callback = payload;
  },
  [SET_MODULE](state, payload) {
    state.module = payload;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
